import { SPECIAL_CHARACTERS_ONLY } from '@/constants/regex.constants'

export function searchTermToRegex(term: string[] | string): RegExp {
  let regex: RegExp | null = null

  if (Array.isArray(term)) {
    let regexString = escapeRegExp(term[0])

    for (const t of term.slice(1)) {
      regexString = `${regexString}|${escapeRegExp(t)}`
    }

    regex = new RegExp(regexString, 'gi')
  } else {
    regex = new RegExp(escapeRegExp(term), 'gi')
  }

  return regex
}

export function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function testStringForSpecialCharactersOnly(text: string): boolean {
  return SPECIAL_CHARACTERS_ONLY.test(text)
}

export function testStringForWordCount(text: string, count: number): boolean {
  const regExp = new RegExp(`(?:\\S+\\s+){${count}}\\S+`)

  return regExp.test(text)
}
